// extracted by mini-css-extract-plugin
export default {"container":"detail_container__L-HI-","table":"detail_table__d4jeS","d-flex":"detail_d-flex__2uM4p"};